import { EditContratPage } from "@features/rh/contrats/components/EditContratPage";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { FileEdit } from "lucide-react";

export const Route = createFileRoute("/_app/rh/contrats/$id/edit")({
  loader: requirePermission(PERMISSIONS.RH.CONTRATS.EDIT),
  staticData: {
    title: "Modifier un contrat",
    icon: FileEdit,
    permission: PERMISSIONS.RH.CONTRATS.EDIT,
    section: "App",
    showInBreadcrumb: true,
  },
  component: EditContratPage,
});
